import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { ArrowUp, ArrowUpRight } from "lucide-react";

export default function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="bg-[#24291E] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo variant="light" />
            <p className="mt-8 text-white/70 leading-relaxed max-w-xs">
              A practical approach.<br />
              A professional standard.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-white/60 text-sm mb-5">Company</div>
            <ul className="space-y-3">
              <li><Link to="/" className="hover:text-[#B29774] transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#B29774] transition-colors">About</Link></li>
              <li><Link to="/services" className="hover:text-[#B29774] transition-colors">Services</Link></li>
              <li><Link to="/projects" className="hover:text-[#B29774] transition-colors">Projects</Link></li>
              <li><Link to="/contact" className="hover:text-[#B29774] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-white/60 text-sm mb-5">Contact</div>
            <div className="text-white/90 leading-relaxed">
              Mohan Ltd<br />12 Thanet Place<br />CR0 1QP<br />United Kingdom
            </div>
            <a href="tel:+447405681929" className="block mt-5 font-medium">+44 7405681929</a>
            <Link to="/contact" className="inline-flex items-center gap-1 mt-4 text-[#B29774] group">
              Make an enquiry <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <div className="lg:col-span-1 flex lg:justify-end">
            <button
              onClick={scrollTop}
              aria-label="Back to top"
              className="w-12 h-12 border border-white/25 flex items-center justify-center hover:bg-[#B29774] hover:border-[#B29774] transition-colors"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-white/60 text-sm">
          <div>© {new Date().getFullYear()} Mohan Ltd. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Cookie Policy</a>
            <a href="#" className="hover:text-white">Terms & Conditions</a>
          </div>
        </div>

        <div className="mt-3 text-white/40 text-xs">
          Architectural photography is illustrative and does not represent completed Mohan Ltd projects.
        </div>
      </div>
    </footer>
  );
}
